import type { GetExperimentByIdResponse } from '../types/api';
import type { Experiment } from '../types/app';

export function experimentMapper(data: GetExperimentByIdResponse['data']): Experiment {
  return {
    id: data.id,
    name: data.name,
    status: data.status,
    instanceName: data.instance_name,
    definition: data.definition,
    control: data.control,
    variations: data.variations,
    splits: data.splits,
    createdAt: data.created_at,
    experimentListNumber: data.experiment_list_number,
  };
}
